import classes from "./Section1.module.css";
import { section1Data } from "../../../data/home";

export default function Section1() {
  return (
    <section className={classes.section}>
      <div className={classes.shell}>
        <div className={classes.features}>
          {section1Data.map(({ icon: Icon, title, description }, index) => (
            <article
              className={classes.feature}
              key={title}
            >
              {Icon && (
                <div className={classes.icon} aria-hidden="true">
                  <Icon />
                </div>
              )}

              <h3 className={classes.title}>{title}</h3>

              <p className={classes.description}>{description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
